<template>
  <div class="gonggaoxq">
    <div class="header">
      <div style="width: 1200px;margin: 0 auto">
        <div class="h1">新闻中心</div>
        <div class="h2">News Consultation Center</div>
      </div>
    </div>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item to="/home">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/newslist">新闻资讯</el-breadcrumb-item>
        <el-breadcrumb-item>资讯详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="xq">
        <div class="title">{{datas.title}}</div>
        <div class="h1">
          <span>发布时间：{{datas.createTime}}</span>
          <span style="margin-left: 20px" >来源：{{datas.source}}</span>
        </div>
        <el-divider></el-divider>
        <div v-html="datas.content">
        </div>
<!--        <fujian style="margin-top: 50px" :files="datas.accessorySet" v-if="datas.accessorySet" :showtitle="true"></fujian>-->
      </div>
    </div>
  </div>
</template>

<script>
// import fujian from '../common/fujian.vue'
// import {filesub} from '../../utils/index'
import {newsdetail} from "@/request/moudle";
export default {
  name: "gonggaoxq",
  components:{
    // fujian
  },
  data(){
    return {
      // filesub:filesub,
      datas:''
    }
  },
  created() {
    this.loadxq()
  },
  methods:{
    loadxq(){
      this.$api.index.newsdetail({
        id:this.$route.query.id
      }).then((res)=>{
          this.datas=res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .gonggaoxq{
     background: #fff;
    .fujian{
      margin-top: 50px;
      .as{
        line-height: 25px;
        color:  #409EFF;
      }
    }
    .header{
      height: 140px;
      background: url("../../assets/banner/news.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 90px;
      color: #fff;
      .h1{
        font-size: 42px;
        font-weight: 500;
      }
      .h2{
        font-size: 22px;
        line-height: 50px;
      }
    }
    .content{
      width: 1200px;
      margin: 20px auto;
      .xq{
        background: #fff;
        min-height: calc(100vh - 350px);
        margin-top: 20px;
        padding: 20px 0;
      }
      .title{
        color: #292929;
        font-weight: bolder;
        font-size: 20px;
      }
      .h1{
        line-height: 50px;
        color: #747474;
        span{
          margin-right: 50px;
        }
      }
    }
  }
</style>